// third-party
import { createSlice, createSelector } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------
const dayjs = require('dayjs');

const initialState = {
    page: 0,
    rowsPerPage: 25,

    isLoading: false,
    isLoading2: false,
    message: '',

    testRequest: [],
    testRequestData: {},
    testRequestDetailsByTestRequestId: [],
    columnFilter: {
        sampleId: {
            appliedList: [],
            checkedList: []
        },
        products: {
            appliedList: [],
            checkedList: []
        },
        sampleType: {
            appliedList: [],
            checkedList: []
        },
        testType: {
            appliedList: [],
            checkedList: []
        },
        batch: {
            appliedList: [],
            checkedList: []
        },
        customers: {
            appliedList: [],
            checkedList: []
        },
        branches: {
            appliedList: [],
            checkedList: []
        },
        status: {
            appliedList: [],
            checkedList: []
        },
        billingStatus: {
            appliedList: [],
            checkedList: []
        },
        customersRef: {
            appliedList: [],
            checkedList: []
        },
        tatDate: {
            appliedList: [],
            checkedList: [
                {
                    startDate: dayjs(new Date(new Date() - 24 * 60 * 60 * 1000)).format('MM-DD-YYYY'),
                    endDate: dayjs(new Date()).format('MM-DD-YYYY')
                }
            ]
        },
        reqDate: {
            appliedList: [],
            checkedList: [
                {
                    startDate: dayjs(new Date(new Date() - 24 * 60 * 60 * 1000)).format('MM-DD-YYYY'),
                    endDate: dayjs(new Date()).format('MM-DD-YYYY')
                }
            ]
        }
    },
    columnFilterTwo: {
        sampleId: {
            appliedList: [],
            checkedList: []
        },
        products: {
            appliedList: [],
            checkedList: []
        },
        sampleType: {
            appliedList: [],
            checkedList: []
        },
        testType: {
            appliedList: [],
            checkedList: []
        },
        batch: {
            appliedList: [],
            checkedList: []
        },
        customersRef: {
            appliedList: [],
            checkedList: []
        },
        customers: {
            appliedList: [],
            checkedList: []
        },
        branches: {
            appliedList: [],
            checkedList: []
        },
        status: {
            appliedList: [],
            checkedList: []
        },
        tatDate: {
            appliedList: [],
            checkedList: [
                {
                    startDate: dayjs(new Date(new Date() - 24 * 60 * 60 * 1000)).format('MM-DD-YYYY'),
                    endDate: dayjs(new Date()).format('MM-DD-YYYY')
                }
            ]
        },
        reqDate: {
            appliedList: [],
            checkedList: [
                {
                    startDate: dayjs(new Date(new Date() - 24 * 60 * 60 * 1000)).format('MM-DD-YYYY'),
                    endDate: dayjs(new Date()).format('MM-DD-YYYY')
                }
            ]
        }
    },
    columnFilterThree: {
        sampleId: {
            appliedList: [],
            checkedList: []
        },
        products: {
            appliedList: [],
            checkedList: []
        },
        sampleType: {
            appliedList: [],
            checkedList: []
        },
        testType: {
            appliedList: [],
            checkedList: []
        },
        batch: {
            appliedList: [],
            checkedList: []
        },
        customersRef: {
            appliedList: [],
            checkedList: []
        },
        customers: {
            appliedList: [],
            checkedList: []
        },
        branches: {
            appliedList: [],
            checkedList: []
        },
        status: {
            appliedList: [],
            checkedList: []
        },
        tatDate: {
            appliedList: [],
            checkedList: [
                {
                    startDate: dayjs(new Date(new Date() - 24 * 60 * 60 * 1000)).format('MM-DD-YYYY'),
                    endDate: dayjs(new Date()).format('MM-DD-YYYY')
                }
            ]
        },
        reqDate: {
            appliedList: [],
            checkedList: [
                {
                    startDate: dayjs(new Date(new Date() - 24 * 60 * 60 * 1000)).format('MM-DD-YYYY'),
                    endDate: dayjs(new Date()).format('MM-DD-YYYY')
                }
            ]
        }
    },
    columnFilterFour: {
        sampleId: {
            appliedList: [],
            checkedList: []
        },
        products: {
            appliedList: [],
            checkedList: []
        },
        sampleType: {
            appliedList: [],
            checkedList: []
        },
        testType: {
            appliedList: [],
            checkedList: []
        },
        batch: {
            appliedList: [],
            checkedList: []
        },
        customersRef: {
            appliedList: [],
            checkedList: []
        },
        customers: {
            appliedList: [],
            checkedList: []
        },
        branches: {
            appliedList: [],
            checkedList: []
        },
        status: {
            appliedList: [],
            checkedList: []
        },
        tatDate: {
            appliedList: [],
            checkedList: [
                {
                    startDate: dayjs(new Date(new Date() - 24 * 60 * 60 * 1000)).format('MM-DD-YYYY'),
                    endDate: dayjs(new Date()).format('MM-DD-YYYY')
                }
            ]
        },
        reqDate: {
            appliedList: [],
            checkedList: [
                {
                    startDate: dayjs(new Date(new Date() - 24 * 60 * 60 * 1000)).format('MM-DD-YYYY'),
                    endDate: dayjs(new Date()).format('MM-DD-YYYY')
                }
            ]
        }
    }
};

const slice = createSlice({
    name: 'testRequest',
    initialState,
    reducers: {
        // Pagination
        setPage(state, action) {
            state.page = action.payload;
        },
        setRowsPerPage(state, action) {
            state.rowsPerPage = action.payload;
        },
        // Pagination

        // table filters
        setColumnCheckedList(state, action) {
            const { columnName, data, status, listType, newValue, columnFilterName } = action.payload;
            if (listType === 'DATE' && data) {
                //
                // data =>  startDate or endDate
                //
                let tempColumnFilterOne = { ...state[columnFilterName] };

                tempColumnFilterOne[columnName].checkedList[0][data] = newValue;
                state[columnFilterName] = { ...tempColumnFilterOne };
                tempColumnFilterOne = {};
            } else if (status) {
                // status refers to checkbox status
                // new item is checked
                // if a new item is checked it will always enter the checked list
                // data ===> id / name based on filter type
                let tempColumnFilterOne = { ...state[columnFilterName] };
                tempColumnFilterOne[columnName].checkedList.push(data);

                state[columnFilterName] = { ...tempColumnFilterOne };
                tempColumnFilterOne = {};
            } else {
                // if the item is getting unchecked that may be in a part of appliedList or checkedList ( we need to hydrate the checklist for consistency )
                // but need to keep in mind untill apply button is pressed don't remove or add to the appliedList
                // That means if item is in the applied list it must be on the checklist
                // on press of apply Button Checked list's data is copied to the Applied list
                let tempColumnFilterOne = { ...state[columnFilterName] };
                let i = 0;
                // eslint-disable-next-line no-plusplus
                for (i; i < tempColumnFilterOne[columnName].checkedList.length; i++) {
                    if (tempColumnFilterOne[columnName].checkedList[i].id === data.id) {
                        break;
                    }
                }
                tempColumnFilterOne[columnName].checkedList.splice(i, 1);

                state[columnFilterName] = { ...tempColumnFilterOne };

                tempColumnFilterOne = {};
            }
        },
        clearUnsavedCheckList(state, action) {
            const { columnName, listType, columnFilterName } = action.payload;
            if (columnName && listType !== 'DATE') {
                let tempColumnFilterOne = { ...state[columnFilterName] };
                tempColumnFilterOne[columnName].checkedList = [...tempColumnFilterOne[columnName].appliedList];
                state[columnFilterName] = { ...tempColumnFilterOne };
                tempColumnFilterOne = {};
            } else {
                // eslint-disable-next-line no-lonely-if
                if (columnName) {
                    // DATE list-type
                    let tempColumnFilterOne = { ...state[columnFilterName] };
                    if (tempColumnFilterOne[columnName].appliedList.length > 0) {
                        // make checklist same as applied list on close of menu
                        tempColumnFilterOne[columnName].checkedList = [...tempColumnFilterOne[columnName].appliedList];
                        state[columnFilterName] = { ...tempColumnFilterOne };
                        tempColumnFilterOne = {};
                    } else {
                        tempColumnFilterOne[columnName].checkedList = [
                            {
                                startDate: dayjs(new Date(new Date() - 24 * 60 * 60 * 1000)).format('MM-DD-YYYY'),
                                endDate: dayjs(new Date()).format('MM-DD-YYYY')
                            }
                        ];
                        state[columnFilterName] = { ...tempColumnFilterOne };
                        tempColumnFilterOne = {};
                    }
                }
            }
        },
        updateAppliedList(state, action) {
            const { updateType, columnName, listType, columnFilterName } = action.payload;
            let tempColumnFilterOne = { ...state[columnFilterName] };
            if (updateType === 'UPDATE') {
                // new checked list moves to the applied list
                // need to avoid dublicate values
                if (listType === 'DATE') {
                    tempColumnFilterOne[columnName].appliedList = [
                        {
                            startDate: tempColumnFilterOne[columnName].checkedList[0].startDate,
                            endDate: tempColumnFilterOne[columnName].checkedList[0].endDate
                        }
                    ];
                } else {
                    tempColumnFilterOne[columnName].appliedList = [];
                    tempColumnFilterOne[columnName].checkedList.forEach((item) => {
                        //  if (!tempExistingAppliedListObj[item.id])
                        tempColumnFilterOne[columnName].appliedList.push(item);
                    });
                }

                state[columnFilterName] = { ...tempColumnFilterOne };
                // tempExistingAppliedListObj = {};
            } else if (updateType === 'CLEAR') {
                if (listType === 'DATE') {
                    tempColumnFilterOne[columnName].appliedList = [];
                    tempColumnFilterOne[columnName].checkedList = [
                        {
                            startDate: dayjs(new Date(new Date() - 24 * 60 * 60 * 1000)).format('MM-DD-YYYY'),
                            endDate: dayjs(new Date()).format('MM-DD-YYYY')
                        }
                    ];
                } else {
                    tempColumnFilterOne[columnName].appliedList = [];
                    tempColumnFilterOne[columnName].checkedList = [];
                }
            }
            tempColumnFilterOne = {};
        },

        // table filters
        startAddingNewTest(state, action) {
            state.isLoading = true;
        },
        startTestRequestStatusUpdate(state, action) {
            state.isLoading = true;
        },
        startAllTestRequest(state, action) {
            state.isLoading = true;
            state.isLoading2 = true;
        },
        setTestRequest(state, action) {
            state.testRequest = action.payload;
        },
        startTestRequestData(state, action) {
            state.isLoading = true;
        },
        setTestRequestData(state, action) {
            state.testRequestData = action.payload;
        },
        startDeleteTestByID(state, action) {
            state.isLoading = true;
        },
        startTestRequestDataByFilter(state, action) {
            state.isLoading = true;
            state.isLoading2 = true;
        },
        // // Details Table Data
        startUpdateTestRequestData(state, action) {
            state.isLoading = true;
        },
        startTestRequestDetailsByTestRequestId(state, action) {
            state.isLoading = true;
        },
        setTestRequestDetailsByTestRequestId(state, action) {
            state.testRequestDetailsByTestRequestId = action.payload;
        },
        startAddMoreTestReqDetail(state, action) {
            state.isLoading = true;
        },
        startUpdateIterationOnTestReq(state, action) {
            state.isLoading = true;
        },
        startUpdateCustomer(state, action) {
            state.isLoading = true;
        },
        // ////////////////////
        completedAction(state, action) {
            state.isLoading = false;
            state.isLoading2 = false;
        }
    }
});
// Actions Exports
export const {
    setPage,
    setRowsPerPage,
    // filters
    setColumnCheckedList,
    clearUnsavedCheckList,
    updateAppliedList,
    ///
    startAddingNewTest,
    startTestRequestStatusUpdate,
    startAllTestRequest,
    setTestRequest,
    startDeleteTestByID,
    startTestRequestData,
    setTestRequestData,
    startTestRequestDataByFilter,
    startUpdateTestRequestData,
    startTestRequestDetailsByTestRequestId,
    setTestRequestDetailsByTestRequestId,
    startAddMoreTestReqDetail,
    startUpdateIterationOnTestReq,
    startUpdateCustomer,
    completedAction
} = slice.actions;
// Reducer
export default slice.reducer;

// selectors

const testRequestsStates = (state) => state.testRequests;
/// Data Loading Selector
export const isLoadingSelector = createSelector([testRequestsStates], (testRequesDataState) => testRequesDataState.isLoading);
export const isLoading2Selector = createSelector([testRequestsStates], (testRequesDataState) => testRequesDataState.isLoading2);
// Test-Requests Selector
export const testRequestsSelector = createSelector([testRequestsStates], (testRequesDataState) => testRequesDataState.testRequest);
// Test-Requests-data
export const testRequestDataSelector = createSelector([testRequestsStates], (testRequesDataState) => testRequesDataState.testRequestData);
// Test-Request-Details-By-Test_request-id
export const testRequestDetailssSelector = createSelector(
    [testRequestsStates],
    (testRequesDataState) => testRequesDataState.testRequestDetailsByTestRequestId
);
// Page Selector
export const pageSelector = createSelector([testRequestsStates], (testRequesDataState) => testRequesDataState.page);
// Row Per Page Selector
export const rowsPerPageSelector = createSelector([testRequestsStates], (testRequesDataState) => testRequesDataState.rowsPerPage);
//  Filters
export const columnFilterSelector = createSelector([testRequestsStates], (testRequesDataState) => testRequesDataState.columnFilter); // /sample-requests/test-requests
export const columnFilterTwoSelector = createSelector([testRequestsStates], (testRequesDataState) => testRequesDataState.columnFilterTwo); // /sample-management/incoming-samples
export const columnFilterThreeSelector = createSelector(
    [testRequestsStates],
    (testRequesDataState) => testRequesDataState.columnFilterThree
); // /sample-management/sample-receipt-list
export const columnFilterFourSelector = createSelector([testRequestsStates], (testRequesDataState) => testRequesDataState.columnFilterFour);
